import React, { useEffect, useState } from "react";
import CelebrationScreen from "../Celebration/CelebrationScreen";
import MeetingPersonalityCard from "../widgets/Module4/MeetingPersonalityCard.jsx";
import { progressService } from "../../../../services/progressService.js";

const RootCauseCelebration = ({ userId, subsectionId, onNextStep }) => {
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    async function loadSelection() {
      try {
        const progress = await progressService.getUserProgress(
          userId,
          subsectionId
        );

        const savedCard = progress?.data?.selectedRootCause;

        if (savedCard) {
          setSelectedCard(savedCard);   // 👍 full object used directly
        }
      } catch (err) {
        console.error("Error loading saved root cause:", err);
      }
    }

    loadSelection();
  }, [userId, subsectionId]);

  if (!selectedCard) return <div className="p-10">Loading...</div>;

  return (
    <CelebrationScreen
      title="Kudos on reaching the 4th milestone in your journey – Underlying Root Cause"
      subtitle=""
      theme="meeting_personality"
      onNext={onNextStep}
      hideBack={true}
      fullScreen={true}
    >
      <MeetingPersonalityCard
        mode="data"
        data={selectedCard}   // 👈 full card object
        userId={userId}
        selectable={false}
        compact={false}
      />
    </CelebrationScreen>
  );
};

export default RootCauseCelebration;
